import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Pencil, Save, Send, X } from "lucide-react";
import { api, formatErr } from "../../lib/api";
import { Card } from "../onboarding/adminUi";
import { btn, fmtDate } from "../leads/PriorityBadge";
import { NutritionInfoForm } from "./NutritionInfoForm";
import { NUTRI_INFO_STEPS, fmtMealTimes } from "../../lib/onboardingSchema";

const fmt = (v) => {
  if (v === "yes") return "Sí";
  if (v === "no") return "No";
  if (Array.isArray(v)) return v.join(", ");
  if (v && typeof v === "object" && ("default" in v || "varies" in v)) return fmtMealTimes(v);
  if (v && typeof v === "object") return Object.entries(v).map(([d, s]) => `${d}: ${[s?.time, s?.duration].filter(Boolean).join(" · ")}`).join("\n");
  return String(v);
};
const FIELDS = NUTRI_INFO_STEPS.flatMap((s) => s.fields);

export const PlayerInfoCard = ({ uid, onChange }) => {
  const [d, setD] = useState(null);
  const [edit, setEdit] = useState(null);
  const load = useCallback(() => api.get(`/admin/nutrition/players/${uid}/info`).then((r) => setD(r.data)).catch((e) => toast.error(formatErr(e))), [uid]);
  useEffect(() => { load(); }, [load]);
  if (!d) return null;
  const save = () => api.put(`/admin/nutrition/players/${uid}/info`, { data: edit }).then(() => { toast.success("Datos guardados"); setEdit(null); load(); onChange && onChange(); }).catch((e) => toast.error(formatErr(e)));
  const ask = () => api.post(`/admin/nutrition/players/${uid}/info-request`).then(async (r) => {
    const url = `${window.location.origin}${r.data.path}`;
    try { await navigator.clipboard.writeText(url); toast.success("Enlace copiado. Envíaselo al futbolista (requiere iniciar sesión)."); } catch { toast.success(`Pide al futbolista que abra: ${url}`); }
    load();
  }).catch((e) => toast.error(formatErr(e)));
  const rows = FIELDS.filter((f) => d.info[f.k] !== undefined);
  return (
    <Card title="Horarios y preferencias del futbolista" testid="adv-info-card" right={
      <div style={{ display: "flex", gap: 8 }}>
        {!edit && <button style={btn("transparent")} onClick={() => setEdit({ ...d.info })} data-testid="adv-info-edit"><Pencil size={14} /> Editar</button>}
        <button style={btn("transparent")} onClick={ask} data-testid="adv-info-request"><Send size={14} /> Pedir al futbolista</button>
      </div>}>
      <div style={{ fontSize: 12, color: "#737373", marginBottom: 8 }} data-testid="adv-info-meta">
        {d.updated_at ? `Actualizado ${fmtDate(d.updated_at)} por ${d.source === "player" ? "el futbolista" : "ti"}` : "Datos del formulario de incorporación"}
        {d.request?.status === "pending" && ` · Solicitado al futbolista el ${fmtDate(d.request.requested_at)} (pendiente)`}
        {d.request?.status === "completed" && ` · Completado por el futbolista el ${fmtDate(d.request.completed_at)}`}
      </div>
      {edit ? (<>
        <NutritionInfoForm data={edit} setData={setEdit} testid="adv-info-form" />
        <div style={{ display: "flex", gap: 8 }}>
          <button style={btn("#dc2626")} onClick={save} data-testid="adv-info-save"><Save size={14} /> Guardar</button>
          <button style={btn("transparent")} onClick={() => setEdit(null)} data-testid="adv-info-cancel"><X size={14} /> Cancelar</button>
        </div>
      </>) : rows.length === 0 ? <div style={{ fontSize: 13, color: "#a3a3a3" }}>Sin datos todavía.</div> : rows.map((f) => (
        <div key={f.k} style={{ display: "grid", gridTemplateColumns: "minmax(140px, 260px) 1fr", gap: 12, padding: "6px 0", borderTop: "1px solid rgba(255,255,255,0.05)", fontSize: 13 }}>
          <span style={{ color: "#a3a3a3" }}>{f.label}</span><span style={{ whiteSpace: "pre-wrap" }}>{fmt(d.info[f.k])}</span>
        </div>
      ))}
    </Card>
  );
};
